import { createContext, useContext } from 'react';
import type { SmartScheduleEvent } from '@/features/smartSchedule/model';
import type { QuickMoveDraft, QuickMoveSource } from '@/features/scheduleQuickMove';

export type QuickMoveController = {
    memberCacheRevision: number;
    openMenu: (event: SmartScheduleEvent, anchor: HTMLElement, onOpenSheet?: () => void) => void;
    getDragSource: (event: SmartScheduleEvent) => QuickMoveSource | null;
    moveDraft: (source: QuickMoveSource, startMinutes: number, date?: string) => QuickMoveDraft;
    formatClock: (minutes: number) => string;
    openSheet: (source: QuickMoveSource, draft: QuickMoveDraft) => void;
    openConfirm: (source: QuickMoveSource, draft: QuickMoveDraft) => void;
};

export const QuickMoveContext = createContext<QuickMoveController | null>(null);
export const useQuickMoveController = () => useContext(QuickMoveContext);
